import React, { useContext } from 'react'

import { useQuery } from '@tanstack/react-query'

import { Icon, ArrowRight, Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import axios from 'axios'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

const RECOMMENDATIONS_PATH = '/api/internal/generator/recommendations'

function RelatedProducts() {
  const { extractingCoreStyles } = useContext(ThreeDStudioPageContext)
  const runId = useThreeDStudioStore(state => state.generation.runId)
  const { data: relatedProducts = [], isLoading: queryLoading } = useQuery({
    queryKey: ['generatorRecommendations', runId],
    queryFn: async () => {
      const { data: response } = await axios.get(RECOMMENDATIONS_PATH, {
        params: { per_page: 8, run_id: runId },
      })

      const items = response.items ?? response.data?.items ?? []

      return items.map((item) => {
        const attrs = item.attributes || {}
        const primaryImage = attrs.primaryImage || {}
        return {
          key: item.id,
          href: attrs.url || '#',
          imagePath: primaryImage.gridUrl || primaryImage.largeUrl || '',
          imageAlt: attrs.imageAlt || attrs.title || 'Related product',
        }
      })
    },
    enabled: Boolean(runId),
  })

  const isLoading = extractingCoreStyles || queryLoading
  const slots = isLoading ? [] : relatedProducts
  const isEmpty = !isLoading && slots.length === 0

  const renderRelatedProducts = () => (
    Array.from({ length: 8 }, (_, index) => {
      const product = slots[index]

      if (!product) {
        return <div className="cgt-model-card__image-container related-products__loading-card shimmer" key={index} />
      }

      return (
        <a key={product.key} href={product.href} target="_blank" rel="noopener noreferrer">
          <img
            className="related-products__list-item-image"
            src={product.imagePath}
            alt={product.imageAlt}
            height={105}
            width={140}
          />
        </a>
      )
    })
  )

  return (
    <div
      className={classnames('related-products', isEmpty && 'related-products--empty')}
      aria-hidden={isEmpty ? 'true' : undefined}
    >
      <div className="related-products__header">
        <span className="related-products__title cgt-heading-50">You may also like</span>
        <Button
          disabled={isLoading}
          trailIcon={<Icon svgComponent={ArrowRight} size="small" />}
          type="ghost-primary"
          variant="with-icon"
          href={isLoading ? '' : '/3d-models?page=1'}
          customClass="related-products__view-more"
          linkAttributes={{ target: '_blank', rel: 'noopener noreferrer' }}
        >
          View more in Marketplace
        </Button>
      </div>
      <div className="related-products__list">{renderRelatedProducts()}</div>
    </div>
  )
}

export default RelatedProducts
